if (document.querySelector(".teaser .teaser__anim-layer")) {
  import("./modules/animLayer.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".form-header-search")) {
  import("./modules/formHeaderSearch.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".header")) {
  import("./modules/header.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".main-nav")) {
  import("./modules/mainNav.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".modal")) {
  import("./modules/modal.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".panel")) {
  import("./modules/panel.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container--1")) {
  import("./modules/swiper1.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container--2")) {
  import("./modules/swiper2.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".swiper-container--3")) {
  import("./modules/swiper3.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".lightbox")) {
  import("./modules/magnificPopup.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".ctype-ce_quote_slider")) {
  import("./modules/quoteSlider.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".js-player")) {
  import("./modules/asVideo.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelector(".page-clinics-and-centers")) {
  import("./modules/ceClinicsCenters.module.js").then((module) => {
    module.init();
  });
}

// const whenComplete = () => {
//   if (document.readyState === "complete") {
//     // Resize
//     let prevScreenWidth = window.innerWidth;
//     window.addEventListener("resize", function (e) {
//       if (!e.isTrigger) {
//         clearTimeout(this._timer);
//         this._timer = setTimeout(() => {
//           if (Math.abs(window.innerWidth - prevScreenWidth) < 99) {
//             // Prevent from further operations for Google mobile browsers
//             // (if event is not real screen change of a device)
//             return;
//           }
//           prevScreenWidth = window.innerWidth;
//           console.log(
//             "%cMain resize",
//             "color:#6f6f6f;font-family:monospace;font-size:12px;"
//           );
//         }, 400);
//       }
//     });
//   } else {
//     setTimeout(function () {
//       whenComplete();
//     }, 400);
//   }
// };
// whenComplete();

// let styleAttempts = 0;
// const stylesComplete = () => {
//   if (styleAttempts > 30) return;
//   styleAttempts += 1;
//   if (document.getElementById("spreld").getAttribute("rel") === "stylesheet") {
//     document.getElementById("sess").remove();
//   } else {
//     setTimeout(function () {
//       stylesComplete();
//     }, 300);
//   }
// };
// stylesComplete();
